<template>
  <div class="sidebar">
    <div class="sidebar__section">

      <!-- dashboard route -->
      <div class="sidebar__section--nav" v-if="item === 'dashboard'">
        <font-awesome-icon icon="poll" />&nbsp;&nbsp;Dashboard
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'dashboard'">
        <routerLink to="/dashboard" active-class="active__link">
          <font-awesome-icon icon="poll" />&nbsp;&nbsp;Dashboard
        </routerLink>
      </div>

      <!-- employee route -->
      <div class="sidebar__section--nav" v-if="item === 'employee'">
        <font-awesome-icon icon="users" />&nbsp;&nbsp;Employee
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'employee'">
        <routerLink to="/employee" active-class="active__link">
          <font-awesome-icon icon="users" />&nbsp;&nbsp;Employee
        </routerLink>
      </div>
    </div>
    <div class="sidebar__section">
      <!-- core HR drop down  -->

      <div class="sidebar__section--nav" @click="viewHrDropDown">
        <span v-if="hr !== 'hr'">
          <font-awesome-icon icon="balance-scale" />&nbsp;&nbsp;Core HR
          <font-awesome-icon icon="angle-down" v-show="!coreHrDropDown" />
          <font-awesome-icon icon="angle-right" v-show="coreHrDropDown" />
        </span>
        <p v-if="hr === 'hr'">
          <font-awesome-icon icon="balance-scale" />&nbsp;&nbsp;Core HR
          <font-awesome-icon icon="angle-down" v-show="!coreHrDropDown" />
          <font-awesome-icon icon="angle-right" v-show="coreHrDropDown" />
        </p>
        <div class="sidebar__section--nav-item" v-show="coreHrDropDown">
          <!-- query route -->
          <div v-if="item === 'query'">
            <span>Query</span>
          </div>
          <div v-if="item !== 'query'">
            <routerLink to="/query" active-class="active__link">Query</routerLink>
          </div>

          <!-- promotion route -->
          <div>
            <div v-if="item === 'promotion'">Promotion</div>
            <div v-if="item !== 'promotion'">
              <routerLink to="/promotion" active-class="active__link">Promotion</routerLink>
            </div>
          </div>
        </div>
      </div>

      <!-- payroll route -->
      <div class="sidebar__section--nav" v-if="item === 'payroll'">
        <font-awesome-icon icon="money-bill-wave" />&nbsp;&nbsp;Payroll
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'payroll'">
        <routerLink to="/payroll" active-class="active__link">
          <font-awesome-icon icon="money-bill-wave" />&nbsp;&nbsp;Payroll
        </routerLink>
      </div>

      <!-- benefit route -->
      <div class="sidebar__section--nav" v-if="item === 'benefit'">
        <font-awesome-icon icon="hand-holding-heart" />&nbsp;&nbsp;Benefits
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'benefit'">
        <routerLink to="/benefits" active-class="active__link">
          <font-awesome-icon icon="hand-holding-heart" />&nbsp;&nbsp;Benefits
        </routerLink>
      </div>
    </div>
    <div class="sidebar__section">
      <!-- contact accoutn officer route -->
      <div class="sidebar__section--nav" v-if="item === 'message'">
        <font-awesome-icon icon="comment-dots" />&nbsp;&nbsp;Contact Account Officer
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'message'">
        <routerLink to="/messaging" active-class="active__link">
          <font-awesome-icon icon="comment-dots" />&nbsp;&nbsp;Contact Account Officer
        </routerLink>
      </div>

      <!-- report route -->
      <div class="sidebar__section--nav" v-if="item === 'report'">
        <font-awesome-icon icon="fax" />&nbsp;&nbsp;Reports
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'report'">
        <routerLink to="/reports" active-class="active__link">
          <font-awesome-icon icon="fax" />&nbsp;&nbsp;Reports
        </routerLink>
      </div>

      <!-- company details route -->
      <div class="sidebar__section--nav" v-if="item === 'companydetails'">
        <font-awesome-icon icon="id-card" />&nbsp;&nbsp;Company Details
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'companydetails'">
        <routerLink to="/company-details" active-class="active__link">
          <font-awesome-icon icon="id-card" />&nbsp;&nbsp;Company Details
        </routerLink>
      </div>
    </div>
    <div class="sidebar__section">


      <!-- wallet route -->
      <div class="sidebar__section--nav" v-if="item === 'wallet'">
          <font-awesome-icon icon="wallet" />&nbsp;&nbsp;Wallet
      </div>
       <div class="sidebar__section--nav" v-if="item !== 'wallet'">
        <routerLink to="/wallet" active-class="active__link">
          <font-awesome-icon icon="wallet" />&nbsp;&nbsp;Wallet
        </routerLink>
      </div>

      <!-- referral route -->
      <div class="sidebar__section--nav" v-if="item === 'referral'">
          <font-awesome-icon icon="people-carry" />&nbsp;&nbsp;Referrals
      </div>
       <div class="sidebar__section--nav" v-if="item !== 'referral'">
        <routerLink to="/referral" active-class="active__link">
          <font-awesome-icon icon="people-carry" />&nbsp;&nbsp;Referrals
        </routerLink>
      </div>

      <!-- document route -->
      <div class="sidebar__section--nav" v-if="item === 'document'">        
          <font-awesome-icon icon="file-alt" />&nbsp;&nbsp;Documents       
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'document'">
        <routerLink to="/document" active-class="active__link">
          <font-awesome-icon icon="file-alt" />&nbsp;&nbsp;Documents
        </routerLink>
      </div>

      <!-- settings route -->
      <div class="sidebar__section--nav" v-if="item === 'setting'">
        <font-awesome-icon icon="cogs" />&nbsp;&nbsp;Settings
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'setting'">
        <routerLink to="/settings" active-class="active__link">
          <font-awesome-icon icon="cogs" />&nbsp;&nbsp;Settings
        </routerLink>
      </div>

      <!-- upgrade route -->
      <div class="sidebar__section--nav" v-if="item === 'upgrade'">       
          <font-awesome-icon icon="paper-plane" />&nbsp;&nbsp;Upgrade
      </div>
       <div class="sidebar__section--nav" v-if="item !== 'upgrade'">
        <routerLink to="/upgrade" active-class="active__link">
          <font-awesome-icon icon="paper-plane" />&nbsp;&nbsp;Upgrade
        </routerLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnboardSidebar",
  data() {
    return {
      coreHrDropDown: false
    };
  },
  props: ["item", "hr"],
  methods: {
    viewHrDropDown() {
      if (this.coreHrDropDown) {
        this.coreHrDropDown = false;
      } else {
        this.coreHrDropDown = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  padding-left: 29px;

  .sidebar__section {
    padding-bottom: 25px;

    .sidebar__section--nav {
      padding-bottom: 25px;
      font-size: 0.938vw;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: left;
      color: #e57414;    
      

      > span {
        color: #000000;
        cursor: pointer;

        &:hover {
          color: #e57414;
        }
      }

      > p {
        color: #e57414;
        cursor: pointer;
      }

      .sidebar__section--nav-item {
        padding-left: 30px;

        > div {
          padding-top: 20px;
          color: #000;

          > span {
            color: #e57414;
          }
        }
      }

      a {
        color: #000;
        text-decoration: none;
        &:hover {
          color: #e57414;
        }
      }
    }
  }

  .active__link {
    color: #e57414 !important;
  }
}
</style>
